import type { ComponentProps } from 'react';

const PrimaryActionButton = ({
  className = '',
  ...props
}: ComponentProps<'button'>) => (
  <button
    type="button"
    // eslint-disable-next-line react/jsx-props-no-spreading
    {...props}
    className={`btn btn-action ${className}`}
  />
);

export default PrimaryActionButton;
